"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUniqueFileName = generateUniqueFileName;
exports.getFilenameAndExtension = getFilenameAndExtension;
function generateUniqueFileName(fileName, extension, files) {
    const fileExtension = extension;
    const baseName = fileName;
    let newName = `${baseName}.${fileExtension}`;
    // Check if the file name already exists, and append a timestamp or index
    let count = 1;
    while (files.some((f) => `${f.fileName}.${f.extension}` === newName)) {
        newName = `${baseName} (${count}).${fileExtension}`;
        count++;
    }
    return newName;
}
function getFilenameAndExtension(fullname) {
    const extension = fullname.includes(".") ? fullname.split(".").pop() : ""; // Get the extension
    const fileName = extension
        ? fullname.slice(0, -extension.length - 1)
        : fullname; // Remove extension part if it exists
    return { fileName, extension: extension ? `${extension}` : "" };
}
